/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-filter',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './search-filter.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterComponent {
  readonly filtros = model<any>();
  readonly palabraClave = signal('');

//  @Output() buscar = new EventEmitter<any>();

  onBuscar() {
   this.filtros.update(filtro => ({
    ...filtro,
    palabraClave: this.palabraClave()
   }))
  // this.buscar.emit(this.filtros());
  }

  onLimpiarBusqueda() {
    this.palabraClave.set('');
    this.filtros.update(filtro =>({
      ...filtro,
      palabraClave: '',
    }))
   // this.buscar.emit(this.filtros());
  }
}
